import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'QUITUS',
  title: 'Qu’est-ce que le Quitus Légal ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Le Quitus est la synthèse de votre dossier administratif. Sa validité dépend de votre dossier légal. Ce document fait l’état de votre dossier administratif à l’instant où vous le générez et vous permet d’attester de votre conformité administrative.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Vos clients ont ainsi une vue d’ensemble de tous vos documents et sont informés de la régularité de votre situation. La mise à jour de vos documents administratifs est primordiale pour assurer à vos clients que vous êtes en règle.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_QUITUS/FR_QUITUS_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Pour télécharger le quitus, rendez-vous dans l’onglet document, puis cliquez sur « Télécharger le quitus »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_QUITUS/FR_QUITUS_2.png`
  }]
};
